import React, { useState, useEffect, useContext } from "react";
import { Button } from "../../Components";
import queryString from "query-string";
import Header from "../commonComponent/Header";
import { upgrade, subscriptionList, checkSubcription, subscriptionActivation, login } from "../API/apiRequest";
import { useNavigate } from "react-router-dom";
import { Context } from "../../context/Context";
import Loader from "../commonComponent/Loader";
import { getOperatorFromSubServiceId, normalizeOperator } from "../config/wapConfig";

function Subscription() {
  const { type } = queryString.parse(window.location.search);
  const msisdn = localStorage.getItem("msisdn");
  const navigate = useNavigate();

  const [isSelected, setIsSelected] = useState(null);
  const [packs, setPacks] = useState([]);
  const [uuid, setUuid] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const { handleShowModal } = useContext(Context);

  useEffect(() => {
    checkSubcription(msisdn)
      .then((resp) => {
        let subServiceId = resp?.subscriptionResponse?.subServiceId;
        const isNewUser = localStorage.getItem("userStatus") === "new";
        const operator = isNewUser
          ? normalizeOperator(localStorage.getItem("operator"))
          : (getOperatorFromSubServiceId(subServiceId) || normalizeOperator(resp?.subscriptionResponse?.operator));
        if (operator) {
          localStorage.setItem("operator", operator)
        }
        if(type === "upgrade"){
          handleSubscriptionList(subServiceId, operator);
        }
        else if(isNewUser){
          const packList = JSON.parse(localStorage.getItem("packList")) || [];
          const madarUuids = [
            "deb47400-0d85-11f1-a8ee-5d429e6c439d",
            "076f39e0-0d86-11f1-9bab-5170599866a9",
            "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef"
          ];
          const libyanaUuids = [
            "db2890c0-67ad-11f0-8756-85ba381b1758",
            "e7ed7e20-67ad-11f0-a69c-2369a5da7f55",
            "1c2d1180-67ae-11f0-8056-cd05cf2b50ec"
          ];
          if (operator === "madar") {
            setPacks(packList.filter(p => madarUuids.includes(p.uuid)));
          } else if (operator === "libyana") {
            setPacks(packList.filter(p => libyanaUuids.includes(p.uuid)));
          } else {
            setPacks(packList);
          }
        }
        else{
        console.log(localStorage.getItem(uuid))
        }
      })
      .catch((err) => {
        navigate("/sub-status?type=technical_error");
        console.log("error in checksub ::", err);
      });
  }, []);


  const handleSubscriptionList = (subServiceId, operator) => {
    setIsLoader(true);
    subscriptionList(msisdn)
      .then((resp) => {
        console.log("subs list api resp::", resp);
        setIsLoader(false);
        if (resp?.messageCode == "00") {
          if (resp?.success?.list) {
            if (type === "upgrade") {
              const allPacks = resp?.success?.list || [];
              let filteredPacks = [];
      console.log("::::::::subServiceId:::::::::::", subServiceId, "operator:", operator)
              if (operator === "madar") {
                if (subServiceId?.toLowerCase() === "3 day madar") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef" || pack.uuid == "076f39e0-0d86-11f1-9bab-5170599866a9"
                  );
                } else if (subServiceId?.toLowerCase() === "monthly madar") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "deb47400-0d85-11f1-a8ee-5d429e6c439d" || pack.uuid == "076f39e0-0d86-11f1-9bab-5170599866a9"
                  );
                } else if (subServiceId?.toLowerCase() === "weekly madar") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "deb47400-0d85-11f1-a8ee-5d429e6c439d" || pack.uuid == "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef"
                  );
                }
              } else {
                if (subServiceId?.toLowerCase() === "daily libyana") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "1c2d1180-67ae-11f0-8056-cd05cf2b50ec" || pack.uuid == "e7ed7e20-67ad-11f0-a69c-2369a5da7f55"
                  );
                } else if (subServiceId?.toLowerCase() === "monthly libyana") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "db2890c0-67ad-11f0-8756-85ba381b1758" || pack.uuid == "e7ed7e20-67ad-11f0-a69c-2369a5da7f55"
                  );
                } else if (subServiceId?.toLowerCase() === "weekly libyana") {
                  filteredPacks = allPacks.filter(
                    (pack) => pack.uuid == "db2890c0-67ad-11f0-8756-85ba381b1758" || pack.uuid == "1c2d1180-67ae-11f0-8056-cd05cf2b50ec"
                  );
                }
              }
console.log("::::filteredPacks:::::", filteredPacks)
              setPacks(filteredPacks);
            } else {
              setPacks(resp?.success?.list);
            }
          } else {
            const modalData = {
              title: "Error",
              body: "لم يتم العثور على قائمة اشتراكات.",
              messageCode: "",
              buttons: [
                {
                  label: "حسنًا",
                  action: "close",
                },
              ],
              handleClick: function (value) {
                if (value === "close") {
                  handleShowModal(false);
                }
                console.log("button clicked");
              },
            };
            handleShowModal(true, modalData);
          }
        } else {
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
        console.log("err in subs list api::", err);
      });
  };

  const handleClick = (index, packUuid) => {
    setIsSelected(index);
    setUuid(packUuid);
    localStorage.setItem("uuid", packUuid);
    console.log("pack index and uuid::", index, packUuid);
  };

  const handleSubscription = (uuid) => {
    if (type === "upgrade") {
      setIsLoader(true);
      upgrade(msisdn, uuid)
        .then((resp) => {
          setIsLoader(false);
          if (resp?.messageCode == "00") {
            navigate(`/otp?type=upgrade`);
          } else {
            navigate("/sub-status?type=technical_error");
          }
        })
        .catch((err) => {
          setIsLoader(false);
          navigate("/sub-status?type=technical_error");
          console.log("err in upgrade api ::", err);
        });
    }
  };

  const handleLogin = (uuid) => {
    login(msisdn, uuid)
      .then((resp) => {
        setIsLoader(false);
        if (resp?.success) {
          navigate(`/otp?type=login`);
        } else {
          setIsLoader(false);
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
      });
  };

  const unSubActivation = (uuid) => {
    console.log("::::::::UNSUB ACTIVATION HIT::::::::")
    subscriptionActivation(msisdn, uuid)
      .then((resp) => {
        console.log("::::::HITTINGG::::::::RESPONSE:::::::", resp, resp?.messageCode)
        setIsLoader(false);
        if (resp?.messageCode == '00') {
          navigate(`/otp?type=subscribe`);
        } else {
          navigate("/sub-status?type=technical_error");
        }
      })
      .catch((err) => {
        setIsLoader(false);
        navigate("/sub-status?type=technical_error");
      });
  };

  const handleButtonClick = () => {
    const activeUuid = uuid || localStorage.getItem("uuid");
    // Guard against firing a request with no pack to act on.
    if (!activeUuid) {
      console.log("::::::NO PACK SELECTED, IGNORING CLICK:::::::");
      return;
    }
    if (type === "upgrade") {
      handleSubscription(activeUuid);
    } else if (localStorage.getItem("userStatus") === "new") {
      handleLogin(activeUuid);
    } else {
      console.log("::::::UNSUB:::::::::")
      unSubActivation(activeUuid);
    }
  };

  console.log("::PACKS::::::::", packs)

  // Disable the action button only while a pack list is visible and nothing is
  // selected yet. The reactivation flow renders no list (packs is empty) and
  // reuses the stored uuid, so it stays enabled.
  const isButtonDisabled = packs.length > 0 && isSelected === null;

  return (
    <>
      {isLoader && <Loader />}
      <div className="cptpl_price bg-darkPurple flex flex-col h-screen">
        <Header />
        <div className="flex-grow mt-36">
          {packs &&
            packs.length > 0 &&
            packs.map((pack, index) => {
              return (
                <SubscritionPacks
                  index={index}
                  handleClick={handleClick}
                  isSelected={isSelected}
                  pack={pack}
                />
              );
            })}
          <div className=" mt-10 flex flex-col items-center">
            <div className="text-white mb-2">للوصول إلى محتوى غير محدود</div>
            <Button
              name={
                type === "upgrade" ? "تحديث الباقة" : localStorage.getItem("userStatus") === "new" ? "تابع للاشتراك" : "تابع لتجديد الاشتراك"
              }
              handleClick={handleButtonClick}
              disabled={isButtonDisabled}
              className={`h-12 bg-buttonYellow rounded-full font-bold  text-darkPurple text-xl w-80 ${isButtonDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function SubscritionPacks({ index, handleClick, isSelected, pack }) {
  console.log("::packs:::::::", pack)
  return (
    <div
      key={index}
      onClick={() => handleClick(index, pack.uuid)}
      className={`border-2 h-20 m-4 rounded-lg flex justify-between ${isSelected === index && "bg-lightPurple"}`}
    >
      <div className="my-auto ml-4 text-xl text-white w-3/4">
        <div>
          {(pack?.uuid == "e7ed7e20-67ad-11f0-a69c-2369a5da7f55" || pack?.uuid == "076f39e0-0d86-11f1-9bab-5170599866a9") ? "الاشتراك الأسبوعي" : (pack?.uuid == "1c2d1180-67ae-11f0-8056-cd05cf2b50ec" || pack?.uuid == "3e557bc0-0d86-11f1-aac1-6f6e63d4a3ef") ? "الاشتراك الشهري" : pack?.uuid == "deb47400-0d85-11f1-a8ee-5d429e6c439d" ? "اشتراك 3 أيام" : "الاشتراك اليومي"}
        </div>
        <div className={`${isSelected === index ? "text-white" : "text-buttonYellow"} font-bold`} >
          <div dir="rtl" className="text-left">
        {pack?.product?.cost} {pack?.product?.cost < 1 ? "درهم" : "دينار"}
        </div>
        </div>
      </div>
      <div className="flex justify-center items-center mr-4">
        <input type="radio" id={"myRadio" + index} name="radioButton" className="hidden" checked={isSelected === index} />
        <label
          htmlFor={"myRadio" + index}
          className={`inline-block w-6 h-6 rounded-full ${isSelected === index ? "bg-white" : "border border-white"} flex justify-center items-center`}
        >
          {isSelected === index && (
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                fill="green"
                stroke="green"
                strokeWidth="2"
                d="M9 16.17L4.83 12l-1.41 1.41L9 19 21 7l-1.41-1.41z"
              />
            </svg>
          )}
        </label>
      </div>
    </div>
  );
}

export default Subscription;

